import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.connector.DOC}
  query IntegrationConnector($tenantId: ID!, $zoneId: ID!, $id: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        intgConnector(id: $id) {
          ...FragmentIntegrationConnector
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.IntegrationConnectorQuery,
    ents.core.integrations.Connector,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'intgConnector',
        fragments.connector.TRANSFORMER,
      ),
    ),
  ),
)

export const execute = graphql.createExecutor<
  graphql.schema.IntegrationConnectorQuery,
  ents.core.integrations.Connector,
  graphql.schema.IntegrationConnectorQueryVariables
>({ query: DOC, transformer: TRANSFORMER })
